export enum AgoraStates {
    Disconnected = "DISCONNECTED",
    Connecting = "CONNECTING",
    Reconnecting = "RECONNECTING",
    Connected = "CONNECTED",
    Disconnecting = "DISCONNECTING"
}